import React, { Component } from 'react'
import {Grid,Cell, List, ListItem, ListItemContent} from 'react-mdl';
class contact extends Component {
    render() {
        return (
            <div className="contact-body">
                <Grid className="contact-grid">
                    <Cell col={6}><h2>Chakka Yamini</h2>
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSr1OGM_q7SNDpz7NBUp_3LjldGAN5WubFscg&usqp=CAU" alt="avatar" style={{height:'250px'}}/>
                    <p style={{width:'75%',margin:'auto',paddingTop:'1em'}}>Hi I am Yamini a Full stack developer. I love to do coding and web designing.My passion towards web developement made me to explore  about different technologies</p>
                    </Cell>
                    <Cell col={6}>
                        <h2>Contact Me</h2>
                        <hr/>

                        <div className="contact-list">
                        <List>
                        <ListItem>
                                <ListItemContent  style={{fontSize:'25px',fontFamily:'Anton'}}>
                                    <i className="fa fa-user" aria-hidden="true"></i>
                                Chakka Yamini</ListItemContent>
                            </ListItem>
                            <ListItem>
                                <ListItemContent  style={{fontSize:'25px',fontFamily:'Anton'}}>
                                    <i className="fa fa-phone-square" aria-hidden="true"></i>
                                9705163493</ListItemContent>
                            </ListItem>
                            <ListItem>
                                <ListItemContent  style={{fontSize:'20px',fontFamily:'Anton'}}>
                                    <i className="fa fa-envelope" aria-hidden="true" style={{fontSize:'25px'}}></i>
                                yaminikanakarao@gmail.com</ListItemContent>
                            </ListItem>
                        </List>
                        </div>

                    </Cell>
                </Grid>
            </div>
        )
    }
}
export default contact;
